module.exports = __webpack_public_path__ + "static/media/Tischlaeufer_40x150.0806e66e.png";